<template>  
  <v-card>
    <v-toolbar flat>      
      <v-text-field flat dense filled
        v-model="term"
        append-icon="search"
        label="Search"
        single-line
        hide-details                
        style="max-width:200px"
      ></v-text-field>    
      <v-btn icon color="blue-grey" :loading="loading" @click="readItems"><v-icon>find_replace</v-icon></v-btn>     
      <v-spacer />
      <v-btn dark color="purple" :loading="uploadLoading" @click="uploadData()"><v-icon left>cloud_upload</v-icon>Upload</v-btn>                    
    </v-toolbar>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">            
            <v-data-table dense 
              :search="term"
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="15"               
              :options.sync="pagination" 
              must-sort                       
            >               
              <template v-slot:item.no="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
              <template v-slot:item.address="{ item }">
                {{item.address}}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'survey/respon/form',query:{jilid_id:$route.query.jilid_id,id:item.id}}"><v-icon>edit</v-icon></v-btn>
              </template>              
            </v-data-table>            
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>      
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/Respon'

export default {
  data () {
    return {
      tab : 0,
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Date', value:'date'},
        {text:'Code', value:'code'},
        {text:'Name', value:'name'},
        {text:'Phone', value:'phone'},
        {text:'Address', value:'address'},   
        {text:'Surveyor', value:'createdby.username'},     
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,  
      uploadLoading : false,    
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        jilid_id: this.$route.query.jilid_id,
        sort:sortby,
        expand:'kecamatan,tps,kelurahan,kabupaten,propinsi,createdby'
      }

      this.items = model.all();  
      this.loading = false;
      /*model.index(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })*/
    }, 
    
    uploadData(){
      let deleted = [];
      this.items.forEach((item,i)=>{
        this.uploadLoading = true;      
        model.fetch(item).then(res=>{
          if(res.status == 200){
            model.delete((respon)=>{
              return respon.id = item.id;
            });
          }
          this.uploadLoading = false;          
        })
      });   
      setTimeout(()=>{
        this.readItems();
        this.uploadLoading = false;          
      }, 3000);   
    }    
  },  
}
</script>